import type { NavigationMenuItem } from "@nuxt/ui";
import type { PermissionPath } from "@/utils/types/auth";
import type { Role } from "@/utils/types/user";

export interface NavigationLink extends NavigationMenuItem {
  permissions?: PermissionPath[];
  includeRoles?: Role[];
  excludesRoles?: Role[];
}

export const links = [
  [
    {
      label: "แดชบอร์ด",
      icon: "i-somas-chart-bar-vertical-1",
      to: "/",
    },
    {
      label: "รายการคำสั่งซื้อ",
      icon: "i-somas-list-unordered",
      to: { name: "orders-today" },
      permissions: ["orders.view"],
      includeRoles: ["sales", "sales_admin", "super_admin"],
    },
    {
      label: "รายการคำสั่งซื้อ",
      icon: "i-somas-list-unordered",
      to: { name: "orders-summary" },
      permissions: ["orders.view"],
      includeRoles: ["client"],
    },
    {
      label: "รายการคำขอเครดิต",
      icon: "i-somas-credit-card-2",
      to: { name: "requests-today" },
      permissions: ["credit.exception.view", "credit.slip.view"],
      includeRoles: ["sales", "sales_admin", "super_admin"],
    },
    {
      label: "รายการคำขอเครดิต",
      icon: "i-somas-credit-card-2",
      to: { name: "requests" },
      permissions: ["credit.exception.view", "credit.slip.view"],
      includeRoles: [
        "sales_manager",
        "sales_director",
        "credit_admin",
        "credit_director",
      ],
    },
    {
      label: "รายชื่อร้านค้า",
      icon: "i-somas-store",
      to: { name: "stores" },
      permissions: ["customers.view"],
      includeRoles: ["sales", "sales_admin", "super_admin"],
    },
    {
      label: "ข้อมูลร้านค้าและผู้ติดต่อ",
      icon: "i-somas-store",
      to: { name: "stores-detail" },
      permissions: ["customers.view"],
      includeRoles: ["client"],
    },
    {
      label: "รายชื่อพนักงาน",
      icon: "i-somas-users",
      to: { name: "staffs" },
      permissions: ["user.admin.view"],
      includeRoles: ["super_admin"],
    },
  ],
] satisfies NavigationLink[][];
